import { createRouter, createWebHashHistory } from "vue-router";
import main from "../views/main.vue";
import { ElNotification } from "element-plus";

const routes = [
	{
		path: "/",
		name: "main",
		component: main,
		children: [
			{
				path: "/",
				name: "home",
				component: () => import("../views/home/home.vue"),
			},
			{
				path: "/gwpz",
				name: "gwpz",
				component: () => import("../views/expense/gwpz.vue"),
			},
			{
				path: "/dqpz",
				name: "dqpz",
				component: () => import("../views/expense/dqpz.vue"),
			},
			{
				path: "/zjpz",
				name: "zjpz",
				component: () => import("../views/expense/zjpz.vue"),
			},
			{
				path: "/config_right",
				name: "config_right",
				component: () => import("../views/expense/config_right.vue"),
			},
			{
				path: "/bxqxyhlb",
				name: "bxqxyhlb",
				component: () => import("../views/expense/bxqxyhlb.vue"),
			},
			{
				path: "/splcpz",
				name: "splcpz",
				component: () => import("../views/page/baoxiao/ywliuchengpeizhi.vue"),
			},
			{
				path: "/bxrz",
				name: "bxrz",
				component: () => import("../views/expense/bxrz.vue"),
			},
			{
				path: "/bxrzxz",
				name: "bxrzxz",
				component: () => import("../views/expense/bxrzxz.vue"),
			},
			{
				path: "/bxqxbmlb",
				name: "bxqxbmlb",
				component: () => import("../views/expense/bxqxbmlb.vue"),
			},
			{
				path: "/bxys",
				name: "bxys",
				component: () => import("../views/expense/bxys.vue"),
			},
			{
				path: "/bxbddy",
				name: "bxbddy",
				component: () => import("../views/expense/bxbddy.vue"),
			},
			{
				path: "/bxbddyn",
				name: "bxbddyn",
				component: () => import("../views/expense/bxbddyn.vue"),
			},
			{
				path: "/bxyslc",
				name: "bxyslc",
				component: () => import("../views/expense/bxyslc.vue"),
			},
			{
				path: "/yskzd",
				name: "yskzd",
				component: () => import("../views/expense/yskzd.vue"),
			},
			{
				path: "/cgsq",
				name: "cgsq",
				component: () => import("../views/expense/before_apply.vue"),
			},
			{
				path: "/sqlsjl",
				name: "sqlsjl",
				component: () => import("../views/expense/before_history.vue"),
			},
			{
				path: "/sqlsjlmx",
				name: "sqlsjlmx",
				component: () => import("../views/expense/sqlsjlmx.vue"),
			},
			{
				path: "/sqbhjl",
				name: "sqbhjl",
				component: () => import("../views/expense/before_reject.vue"),
			},
			{
				path: "/sqbhjlmx",
				name: "sqbhjlmx",
				component: () => import("../views/expense/sqbhjlmx.vue"),
			},
			{
				path: "/jyrytj",
				name: "jyrytj",
				component: () => import("../views/expense/jyrytj.vue"),
			},
			{
				path: "/jybmtj",
				name: "jybmtj",
				component: () => import("../views/expense/jybmtj.vue"),
			},
			{
				path: "/jybmtjmx",
				name: "jybmtjmx",
				component: () => import("../views/expense/jybmtjmx.vue"),
			},
			{
				path: "/ysxmtj",
				name: "ysxmtj",
				component: () => import("../views/expense/ysxmtj.vue"),
			},
			{
				path: "/ysxmtjmx",
				name: "ysxmtjmx",
				component: () => import("../views/expense/ysxmtjmx.vue"),
			},
			{
				path: "/ysxmtjmxmx",
				name: "ysxmtjmxmx",
				component: () => import("../views/expense/ysxmtjmxmx.vue"),
			},
			{
				path: "/tjsq",
				name: "tjsq",
				component: () => import("../views/expense/tjsq.vue"),
			},
			{
				path: "/wdbxd",
				name: "wdbxd",
				component: () => import("../views/expense/after_history.vue"),
			},
			{
				path: "/wdbxdmx",
				name: "wdbxdmx",
				component: () => import("../views/expense/wdbxdmx.vue"),
			},
			{
				path: "/ckbojl",
				name: "ckbojl",
				component: () => import("../views/expense/after_reject.vue"),
			},
			{
				path: "/dwsp",
				name: "dwsp",
				component: () => import("../views/expense/approve_before.vue"),
			},
			{
				path: "/spjl",
				name: "spjl",
				component: () => import("../views/expense/approve_after.vue"),
			},
			{
				path: "/bxjdym",
				name: "bxjdym",
				component: () => import("../views/expense/bxjdym.vue"),
			},
			{
				path: "/hbpz",
				name: "hbpz",
				component: () => import("../views/expense/hbpz.vue"),
			},
			{
				path: "/joblevel",
				name: "joblevel",
				component: () => import("../views/expense/joblevel.vue"),
			},
			{
				path: "/techlevel",
				name: "techlevel",
				component: () => import("../views/expense/techlevel.vue"),
			},
			{
				path: "/kjrk",
				name: "kjrk",
				component: () => import("../views/expense/kjrk.vue"),
			},
			{
				path: "/qxbmlb",
				name: "qxbmlb",
				component: () => import("../views/pzx/qxbmlb.vue"),
			},
			{
				path: "/qxyhlb",
				name: "qxyhlb",
				component: () => import("../views/pzx/qxyhlb.vue"),
			},
		],
	},
	{
		path: "/login",
		name: "login",
		component: () => import("../views/login/login.vue"),
	},
	{
		path: "/404",
		name: "404",
		component: () => import("@/views/noPage/404.vue"),
	},
	{
		path: "/linkLog",
		name: "linkLog",
		component: () => import("@/views/noPage/linkLog.vue"),
	},
	{
		path: "/:catchAll(.*)",
		redirect: "/404",
	},
];

const router = createRouter({
	history: createWebHashHistory(),
	routes,
});

const whiteList = ["login", "linkLog"];
router.beforeEach((to, from, next) => {
	if (localStorage.getItem("token")) {
		next();
	} else {
		if (whiteList.indexOf(to.name) !== -1) {
			next();
		} else {
			ElNotification({
				title: "系统提示",
				message: "未登录，请登录",
				type: "error",
				duration: 3000,
			});
			next({ path: "/login" });
		}
	}
});
export default router;
